import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import Bible from "./components/Bible/Bible";
import Testaments from "./components/Bible/Testaments";
import TestamentVerses from "./components/Bible/TestamentVerses";

import SearchWord from "./components/Bible/SearchWord/SearchWord";
import { startBibleDownloadCache } from "./components/Bible/DownloadCache";

import DailyVerse from "./components/DailyVerse/DailyVerse";
import ScreenSaver from "./components/ScreenSaver/ScreenSaver";
import Contact from "./components/Contact/Contact";
import Home from "./components/Home/Home";
import TopHeader from "./components/Header/TopHeader";
import NewsForm from "./components/News/NewsForm";
import News from "./components/News/News";
import NewsContent from "./components/News/NewsContent";
import ShareTextImage from "./components/TextToImage/ShareTextImage";
import ImageUploadForm from "./components/ImageUpload/ImageUploadForm";
import SongDetails from "./components/Songs/SongDetails";
import SingerAndAlbumList from "./components/Songs/SingerAndAlbumList";
import AdminAuth from "./components/Admin/AdminAuth";
import Songs from "./components/Admin/Songs/Songs";
import Dashboard from "./components/Admin/Dashboard";
import Support from "./components/Authentication/Support";
import PrivacyPolicy from "./components/Authentication/PrivacyPolicy";
import { AuthProvider } from "./components/Authentication/AuthContext";
import Categories from "./components/Articles/Categories";
import SubCategories from "./components/Articles/SubCategories";
import Articles from "./components/Articles/Articles";
import Article from "./components/Articles/Article";
import FindVerse from "./components/Bible/VerseFind/FindVerse";

const DEFAULT_LANGUAGE = "தமிழ்";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem("language");

    if (!storedLanguage) {
      localStorage.setItem("language", DEFAULT_LANGUAGE);
      return DEFAULT_LANGUAGE;
    }

    return storedLanguage;
  });

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  useEffect(() => {
    startBibleDownloadCache();
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/home", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <AuthProvider>
      <div>
        {location.pathname !== "/" && (
          <TopHeader language={language} setLanguage={setLanguage} />
        )}

        <div>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />

            <Route
              path="/old-testament"
              element={<Testaments testamentType="old" />}
            />

            <Route
              path="/old-testament/chapters/:book/:chapter"
              element={<TestamentVerses testamentType="old" />}
            />

            <Route
              path="/new-testament"
              element={<Testaments testamentType="new" />}
            />
            <Route
              path="/new-testament/chapters/:book/:chapter"
              element={<TestamentVerses testamentType="new" />}
            />

            <Route path="/bible" element={<Bible />} />
            <Route path="/bible-verse-find" element={<FindVerse />} />
            <Route path="/search-verse-by-word" element={<SearchWord />} />

            <Route path="/daily-verse" element={<DailyVerse />} />
            <Route path="/screen-saver" element={<ScreenSaver />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/newsform" element={<NewsForm />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsContent />} />

            <Route path="/singers" element={<SingerAndAlbumList />} />
            <Route path="/songs/:id" element={<SongDetails />} />

            <Route path="/shareimages" element={<ShareTextImage />} />
            <Route path="/imageupload" element={<ImageUploadForm />} />

            <Route path="/admin" element={<AdminAuth />} />
            <Route path="/Songs" element={<Songs />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/admin/dashboard/*" element={<Dashboard />} />

            <Route path="/support" element={<Support />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />

            <Route path="/Categories" element={<Categories />} />
            <Route
              path="/subcategories/:categoryId"
              element={<SubCategories />}
            />
            <Route
              path="/articles-list/:subcategoryId"
              element={<Articles />}
            />
            <Route path="/article/:articleId" element={<Article />} />
          </Routes>
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
